import React, {Component} from 'react'
import "../styles/index.scss"
import MergerSetPage from './MergerSetPage'

class MergerSetPageContainer extends Component {
    render() {
        return (
            <div className="MergerPageContainer">
                <div className='container-fluid min-vh-100 bg-white shadow-sm py-3'>
                    {/* <div className='row'> */}
                        <div className='col-12 mx-auto'>
                            <MergerSetPage/>
                        </div>
                    {/* </div> */}
                </div>
            </div>
        )
    }
}

export default MergerSetPageContainer
